<div class="error">
  <h1 class="error__title">404</h1>
  <div class="error__subtitle">Nu am găsit pagina pe care o cauți</div>
  <div class="error__description">Dacă întâmpini probleme ne găsești la  <br /><a (click)="trackConversion('Pv7pCN3In6QZELWMoq4q')" [href]="'tel:' + phoneRaw">{{phone}}</a> / <a [href]="'mailto:' + email">{{email}}</a></div>
  <div class="error__navigation">
  <button mat-raised-button (click)="back()">Înapoi</button>
  <button mat-raised-button color="primary" (click)="refresh()">Pagina principală</button>
  </div>
</div>
